module.exports = __webpack_public_path__ + "img/map_home-plate-mezzanine.0143a823.jpg";